import isFacetedNavPage from "./isFacetedNavPage";
import {
  composeCategoryNavigationLinks,
  composeFacetedNavigationLinks
} from "../helpers";

const getCategorySeoLinks = state => {
  const facetedFlag = isFacetedNavPage(state);

  const categoryNavigationLinks = composeCategoryNavigationLinks(state);

  const facetedNavigationLinks = composeFacetedNavigationLinks(state);

  return {
    primarySeoLinks: facetedFlag
      ? facetedNavigationLinks
      : categoryNavigationLinks,
    secondarySeoLinks: facetedFlag
      ? categoryNavigationLinks
      : facetedNavigationLinks
  };
};

export default getCategorySeoLinks;
